export default __webpack_public_path__ + "static/article-budgeting-for-your-honeymoon-f6ba79056180d9cd25dc66c052ff12e1.jpg";